import { Grid, Stack } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import type { PartyDto } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";
import { formatPhone } from "Utils/PhoneUtils";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form;

type Props = {
  party: PartyDto;
  genderValue?: string;
};

export const SelfEmployedSection = ({
  party: {
    companyName,
    firstName,
    lastName,
    companyNumber,
    taxNumber,
    vatNumber,
    personalNumber,
    birthDate,
    birthPlace,
    nationality,
    otherNationalities,
    phone,
    verifiedPhone,
    email,
  },
  genderValue,
}: Props) => {
  const { t } = useResource();
  const { getCountryName, getCountryNames } = useCountryNameResolver();
  const r = FORM_RESOURCES.SelfEmployed;

  return (
    <Stack gap={4}>
      <FormSection legend={t(r.Legend.Company)} noMargins>
        <Grid container spacing={2}>
          <GridItem label={t(r.CompanyName)} value={companyName} />
          <GridItem label={t(r.FirstName)} value={firstName} />
          <GridItem label={t(r.LastName)} value={lastName} />
          <GridItem label={t(r.CompanyNumber)} value={companyNumber} />
          <GridItem label={t(r.TaxNumber)} value={taxNumber} />
          <GridItem label={t(Resources.Common.VatNumber)} value={vatNumber} />
          <GridItem label={t(r.PersonalNumber)} value={personalNumber} />
          <GridItem label={t(r.BirthDate)} value={formatDate(birthDate)} />
          <GridItem label={t(r.Gender)} value={genderValue} />
          <GridItem label={t(r.BirthPlace)} value={birthPlace} />
          <GridItem
            label={t(Resources.Common.Nationality)}
            value={getCountryName(nationality)}
          />
          {otherNationalities.length > 0 && (
            <GridItem
              label={t(Resources.Common.OtherNationalities)}
              value={getCountryNames(otherNationalities)}
            />
          )}
        </Grid>
      </FormSection>
      <FormSection legend={t(r.Legend.Contact)} noMargins>
        <Grid container spacing={2}>
          <GridItem columns={2} label={t(r.Phone)} value={formatPhone(phone)} />
          <GridItem
            columns={2}
            label={t(r.VerifiedPhone)}
            value={formatPhone(verifiedPhone)}
          />
          <GridItem columns={2} label={t(r.Email)} value={email} />
        </Grid>
      </FormSection>
    </Stack>
  );
};
